import React from "react";
import ModulesAestheticScreen from "../../screens/ModulesAesthetic/ModulesAestheticScreen";

const ModulesServiceContainer = ({ }) => {
  return <ModulesAestheticScreen />;
};

export default ModulesServiceContainer;
